import { CONFIG } from '@gallaghercp/core-frontend';

export const APP_CONFIG: CONFIG = {
  appName: 'Scripps Benefits',
  frontend: 'https://scrippsbenefits.com',
  apiHash: 'https://scrippsbenefits.com/api/1.0',
  api: '/api/2.0',
  modernised: true,
  authHeaders: {
    xServiceProvider: 'scripps-prod-frontend',
    'tenant-id': '65e809c7-df30-4ca8-93eb-a57bba4cd71c',
    'consumer-id': '3569f5c8-aff2-40c9-ab38-49a9a9e4a834',
  },
  commitSHA: '99f7abf',
  provider: 'scripps-prod-frontend',
zoneRouting: [
  {
    id: 2,
    route: 'medical-group',
  },
  {
    id: 3,
    route: 'scripps-health',
  },
],
} as CONFIG;

